module.exports = __webpack_public_path__ + "static/media/impactIcon1.3afcaf0e.png";